<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :breadTxt="'密评咨询'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<p class="t-align-center fz-24 serviceT mt-50">密评咨询</p>
			<p class="t-align-center fz-24 serviceT mt-10 mb-20">Confidential evaluation consultation</p>
			<div class="m-0auto maxw-1400 pb-50">
				<p class="fz-24 f-blue line-50 f-bold">商用密码</p>
				<p class="fz-24 line-26 mb-20">商用密码是指采用特定变换的方法对不属于国家秘密的信息等进行加密保护、安全认证的技术、安全认证的技术、产品和服务。</p>
				
				<p class="fz-24 f-blue line-50 f-bold">密码法规</p>
				<p class="fz-24 line-26 mb-20">第27 条:法律、行政法规和国家有关规定要求使用商用密码进行保护的关键信息基础设施，其运营者应当使用商用密码进行保护，组织开展商用密码应用安全性评估。</p>
				<p class="fz-24 line-26 mb-50">第37条:关键信息基础设施的运营者违反本法第二十七条第一款规定，未按要求使用商用密码，或者未按照要求开展商用密码应用安全性评估的，由密码管理部门责令改正，给予警告，拒不改正或者导致危害网络安全等后果的，处十万元以上一百万元以下罚款，对直接负责的主管人员处一万元以上十万元以下罚款。</p>
				
				<p class="fz-24 f-blue line-50 f-bold">商用密码应用安全性评估定义（简称“密评”）</p>
				<p class="fz-24 line-50">指对采用商用技术、产品和服务集成建设的网络和信息系统中，对其密码应用的合规性、正确性和有效性进行评估。</p>
				
				<img src="../../assets/img/service/u13.png"/>
				
				<p class="fz-24 f-blue line-50 f-bold">密评咨询服务内容</p>
				<img src="../../assets/img/service/u20.png"/>
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1400px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 20px auto;
	border-radius: 15px;
}
.serviceT{
	font-size: 24px;
	font-weight: 800;
}
img{
	width: 100%;
}
</style>